import { render, staticRenderFns } from "./Estates.vue?vue&type=template&id=2b4c969a&scoped=true&"
import script from "./Estates.vue?vue&type=script&lang=js&"
export * from "./Estates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c969a",
  null
  
)

export default component.exports